import { Type } from 'class-transformer';
import { SyncStatusDto } from '../../integrations';

export class ContractSyncStatusMetaDataDto {
  link: string;
}

export class ContractSyncStatusDto extends SyncStatusDto {
  @Type(() => ContractSyncStatusMetaDataDto)
  metadata: ContractSyncStatusMetaDataDto;
}
